import http from '@/services/http'

export default {
  namespaced: true,
  state: {
    fetchInProgress: false,
    setInvestorStatusInProgress: false,
    investors: [],
    nextPageUrl: null,
    previousPageUrl: null,
    totalCount: null,
    page: null,
  },
  mutations: {
    START_FETCH(state, page) {
      state.fetchInProgress = true
      state.page = page
    },
    SET_INVESTOR_TOTAL_COUNT(state, count) {
      state.totalCount = count
    },
    SET_INVESTOR_LIST_DATA(state, investors) {
      state.investors = investors
    },
    STOP_FETCH(state) {
      state.fetchInProgress = false
    },
    ADD_INVESTOR(state, investor) {
      state.investors = state.investors.concat([investor])
    },
    REMOVE_INVESTOR(state, investorId) {
      state.investors = state.investors.filter(
        (investor) => investor.id !== investorId,
      )
    },
    published(state, { investor }) {
      state.investors.forEach((obj) => {
        if (obj.id === investor.id) {
          obj.is_public = true
        }
      })
    },
    unpublished(state, { investor }) {
      state.investors.forEach((obj) => {
        if (obj.id === investor.id) {
          obj.is_public = false
        }
      })
    },
    SET_INVESTOR_STATUS(state, { investor, status }) {
      const idx = state.investors.map((i) => i.id).indexOf(investor.id)

      investor.state = status
      state.investors.splice(idx, 1, investor)
    },
    START_SET_INVESTOR_STATUS(state) {
      state.setInvestorStatusInProgress = true
    },
    STOP_SET_INVESTOR_STATUS(state) {
      state.setInvestorStatusInProgress = false
    },
  },
  actions: {
    fetch,
    fetchAll,
    async remove({ commit }, investorId) {
      const url = `/investors/${investorId}/delete`
      try {
        await http.postAuthed(url)
      } finally {
        commit('REMOVE_INVESTOR', investorId)
      }
    },

    async publish({ commit }, { investor }) {
      commit('published', { investor })
      await http.postAuthed(`/investors/${investor.id}/publish`)
    },
    async unpublish({ commit }, { investor }) {
      commit('unpublished', { investor })
      await http.postAuthed(`/investors/${investor.id}/unpublish`)
    },
    async classifyInvestor({ commit }, { investor, status }) {
      let { startupId } = this.state.user.data
      if (!startupId) {
        startupId = this.state.startupProfile.startup.id
      }
      const investorId = investor.id
      const request = http.postAuthed(
        `/startups/${startupId}/classify-investor`,
        { investorId, state: status },
      )

      commit('START_SET_INVESTOR_STATUS')
      try {
        commit('SET_INVESTOR_STATUS', { investor, status })
        await request
      } catch (error) {
        throw error
      } finally {
        commit('STOP_SET_INVESTOR_STATUS')
      }
    },
  },
}

async function fetch({ commit }, opts) {
  opts = opts || {}
  opts.page = opts.page || 1
  const url = getFetchUrl(opts.startupId)
  if (opts.startupId) {
    delete opts.startupId
  }
  commit('START_FETCH', opts.page)
  try {
    const response = await performFetch(url, opts)
    commit('SET_INVESTOR_LIST_DATA', response.data.results)
    commit('SET_INVESTOR_TOTAL_COUNT', response.data.count)
    return response
  } finally {
    commit('STOP_FETCH')
  }
}

async function fetchAll({ commit, state }, opts) {
  opts = opts || {}
  opts.page_size = opts.page_size || 100
  commit('START_FETCH')
  const url = getFetchUrl(opts.startupId)
  delete opts.startupId
  let response = await performFetch(url, opts)
  // page_size need to be removed as "next" url would already contain it
  delete opts.page_size
  commit('SET_INVESTOR_LIST_DATA', response.data.results)
  commit('SET_INVESTOR_TOTAL_COUNT', response.data.count)
  while (response.data.next) {
    console.log(' opts:', opts)
    response = await performFetch(response.data.next, opts)
    const wholeData = state.investors.concat(response.data.results)
    commit('SET_INVESTOR_LIST_DATA', wholeData)
  }
  commit('STOP_FETCH')
  return response
}

async function performFetch(url, opts) {
  const request = http.getAuthed(url, opts)
  return await request
}

function getFetchUrl(startupId) {
  if (startupId) {
    return `/investors-for-startup/${startupId}`
  } else {
    return '/investors'
  }
}
